import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FinancialService { 

    constructor(private http: HttpClient) { }

    getfinancialService() {
        return this.http.get<any[]>(`${environment.apiUrl}get_financial_services`);
    }    	    
}
